export const translations = {
  es: {
    nav: {
      about: 'Quiénes somos',
      services: 'Servicios',
      mission: 'Misión',
      commitment: 'Compromiso',
      destinations: 'Lugares',
      faq: 'FAQ',
      contact: 'Contacto',
      whatsapp: 'WhatsApp',
    },
    hero: {
      title: 'Taxi turismo aeropuerto y transporte de pasajeros y personal, 24/7 dentro y fuera de la región',
      titleShort: 'Taxi y transporte 24/7 en Antofagasta',
      subtitle: 'Viaje dentro y fuera de la ciudad, servicios de taxi, tours turísticos y traslados a faenas mineras. Te ofrecemos seguridad y calidad en tu viaje.',
      btnWhatsapp: 'Reservar por WhatsApp',
      btnServices: 'Ver servicios',
    },
    about: {
      title: 'Quiénes somos',
      tagline: 'Empresa familiar con raíces en Antofagasta',
      p1: 'Transportes ZAVE SpA es una empresa familiar con raíces en Antofagasta, dedicada al transporte de pasajeros, servicio de taxi y traslado dentro de la región.',
      p2: 'Nacimos del compromiso de ofrecer un servicio de transporte confiable, seguro y profesional, para habitantes, turistas y trabajadores de la zona. Con años de experiencia en la región, conocemos cada rincón de Antofagasta y entendemos las necesidades específicas de nuestros clientes.',
      p3: 'Nos enorgullece ser parte de esta tierra, brindando soluciones de movilidad que conectan personas con sus destinos, ya sea dentro de la ciudad, hacia faenas mineras o descubriendo los atractivos turísticos del norte de Chile.',
    },
    services: {
      title: 'Nuestros servicios',
      taxi: {
        title: 'Servicio de taxi 24/7',
        desc: 'Disponibles las 24 horas, los 7 días de la semana.',
      },
      empresas: {
        title: 'Servicios para empresas y faenas mineras (convenios)',
        desc: 'Convenios con empresas. Traslados de personal y trabajadores.',
      },
      aeropuerto: {
        title: 'Traslado al Aeropuerto (ida y vuelta)',
        desc: 'Servicio puntual y confiable al aeropuerto.',
      },
    },
    mission: {
      title: 'Nuestra misión',
      text: 'Proporcionar servicios de transporte seguros, puntuales y de calidad en Antofagasta y sus alrededores, garantizando la satisfacción de nuestros clientes a través de un servicio profesional, vehículos modernos y conductores experimentados.',
    },
    commitment: {
      title: 'Nuestro compromiso',
      seguridad: { title: 'Seguridad', text: 'Vehículos en óptimas condiciones y conductores profesionales.' },
      puntualidad: { title: 'Puntualidad', text: 'Respetamos tus tiempos y garantizamos llegada a horario.' },
      confiabilidad: { title: 'Confiabilidad', text: 'Servicio operativo sin importar la hora o el día.' },
      calidad: { title: 'Calidad', text: 'Flota moderna y cómoda para tu comodidad.' },
      transparencia: { title: 'Transparencia', text: 'Tarifas claras y honestas.' },
    },
    floatingWa: 'Abrir WhatsApp para cotizar',
    scrollToTop: 'Subir al inicio',
    ctaFinal: {
      title: '¿Listo para tu próximo viaje?',
      subtitle: 'Reserva ahora por WhatsApp y viaja con seguridad, puntualidad y calidad. Estamos disponibles las 24 horas.',
      btn: 'Reservar por WhatsApp',
      ariaLabel: 'Reservar por WhatsApp',
    },
    contact: {
      title: 'Contacto',
      whatsapp: 'WhatsApp',
      phone: 'Teléfono',
      email: 'Email',
      schedule: 'Horario',
      instagram: 'Instagram',
      btnWhatsapp: 'Reservar por WhatsApp',
    },
    footer: {
      brand: 'Transportes ZAVE SpA',
      location: 'Antofagasta, Región de Antofagasta, Chile',
      schedule: 'Disponibles 24/7',
      rights: 'Todos los derechos reservados.',
      navTitle: 'Navegación',
      contactTitle: 'Contacto',
      faq: 'Preguntas frecuentes',
      destinations: 'Lugares',
    },
    stats: {
      title: 'Nuestros números',
      trips: 'Viajes realizados',
      clients: 'Clientes satisfechos',
      years: 'Años de experiencia',
    },
    faq: {
      title: 'Preguntas frecuentes',
      items: [
        { q: '¿Cómo reservo un traslado?', a: 'Puedes reservar por WhatsApp escribiendo al +56 9 9167 3285. Indica origen, destino, fecha, hora y cantidad de pasajeros. Te confirmaremos la cotización de inmediato.' },
        { q: '¿Están disponibles 24 horas?', a: 'Sí, operamos las 24 horas del día, los 7 días de la semana, incluyendo festivos. Ideal para vuelos temprano o tarde.' },
        { q: '¿Aceptan pagos con tarjeta?', a: 'Aceptamos efectivo y transferencia. Consulta por otras formas de pago al cotizar.' },
        { q: '¿Hacen traslados a faenas mineras?', a: 'Sí, tenemos convenios con empresas y realizamos traslados de personal a faenas mineras en la región.' },
      ],
    },
    destinations: {
      title: 'Lugares y destinos',
      subtitle: 'Cotiza por WhatsApp para confirmar tu traslado.',
      items: [
        'Ciudad • Aeropuerto • Faenas mineras — Un solo contacto para todo tu traslado 24/7.',
        'Antofagasta, Tocopilla, Mejillones, Taltal, Calama: toda la región a tu alcance. Viaja seguro, viaja puntual, viaja con ZAVE.',
      ],
      mapTitle: 'Mapa Región de Antofagasta',
      btn: 'Cotizar por WhatsApp',
    },
    testimonials: {
      title: 'Lo que dicen nuestros clientes',
      items: [
        { name: 'María G.', text: 'Excelente servicio al aeropuerto. Puntuales y muy amables. Los recomiendo.', role: 'Pasajera' },
        { name: 'Carlos R.', text: 'Usamos ZAVE para traslados de personal a faena. Siempre confiables.', role: 'Empresa minera' },
        { name: 'Ana L.', text: 'Viaje a San Pedro impecable. Conocen bien la ruta y el vehículo muy cómodo.', role: 'Turista' },
      ],
    },
  },
  en: {
    nav: {
      about: 'About us',
      services: 'Services',
      mission: 'Mission',
      commitment: 'Commitment',
      destinations: 'Places',
      faq: 'FAQ',
      contact: 'Contact',
      whatsapp: 'WhatsApp',
    },
    hero: {
      title: 'Taxi tourism airport and passenger and staff transport, 24/7 within and outside the region',
      titleShort: 'Taxi & transport 24/7 in Antofagasta',
      subtitle: 'Travel within and outside the city, taxi services, tourist tours and transfers to mining sites. We offer you safety and quality on your trip.',
      btnWhatsapp: 'Book via WhatsApp',
      btnServices: 'View services',
    },
    about: {
      title: 'About us',
      tagline: 'A family business with roots in Antofagasta',
      p1: 'Transportes ZAVE SpA is a family-owned company with roots in Antofagasta, dedicated to passenger transport, taxi service and transfers within the region.',
      p2: 'We were born from the commitment to offer a reliable, safe and professional transport service for residents, tourists and workers in the area. With years of experience in the region, we know every corner of Antofagasta and understand the specific needs of our clients.',
      p3: 'We are proud to be part of this land, providing mobility solutions that connect people with their destinations, whether within the city, to mining sites or discovering the tourist attractions of northern Chile.',
    },
    services: {
      title: 'Our services',
      taxi: {
        title: '24/7 taxi service',
        desc: 'Available 24 hours, 7 days a week.',
      },
      empresas: {
        title: 'Services for companies and mining sites (agreements)',
        desc: 'Agreements with companies. Staff and worker transfers.',
      },
      aeropuerto: {
        title: 'Airport transfer (round trip)',
        desc: 'Punctual and reliable service to the airport.',
      },
    },
    mission: {
      title: 'Our mission',
      text: 'To provide safe, punctual and quality transport services in Antofagasta and its surroundings, guaranteeing customer satisfaction through professional service, modern vehicles and experienced drivers.',
    },
    commitment: {
      title: 'Our commitment',
      seguridad: { title: 'Safety', text: 'Vehicles in optimal condition and professional drivers.' },
      puntualidad: { title: 'Punctuality', text: 'We respect your time and guarantee on-time arrival.' },
      confiabilidad: { title: 'Reliability', text: 'Service operational regardless of time or day.' },
      calidad: { title: 'Quality', text: 'Modern and comfortable fleet for your comfort.' },
      transparencia: { title: 'Transparency', text: 'Clear and honest rates.' },
    },
    floatingWa: 'Open WhatsApp to get a quote',
    scrollToTop: 'Scroll to top',
    ctaFinal: {
      title: 'Ready for your next trip?',
      subtitle: 'Book now via WhatsApp and travel with safety, punctuality and quality. We are available 24 hours.',
      btn: 'Book via WhatsApp',
      ariaLabel: 'Book via WhatsApp',
    },
    contact: {
      title: 'Contact',
      whatsapp: 'WhatsApp',
      phone: 'Phone',
      email: 'Email',
      schedule: 'Schedule',
      instagram: 'Instagram',
      btnWhatsapp: 'Book via WhatsApp',
    },
    footer: {
      brand: 'Transportes ZAVE SpA',
      location: 'Antofagasta, Antofagasta Region, Chile',
      schedule: 'Available 24/7',
      rights: 'All rights reserved.',
      navTitle: 'Navigation',
      contactTitle: 'Contact',
      faq: 'FAQ',
      destinations: 'Places',
    },
    stats: {
      title: 'Our numbers',
      trips: 'Trips completed',
      clients: 'Satisfied clients',
      years: 'Years of experience',
    },
    faq: {
      title: 'Frequently asked questions',
      items: [
        { q: 'How do I book a transfer?', a: 'You can book via WhatsApp at +56 9 9167 3285. Indicate origin, destination, date, time and number of passengers. We will confirm the quote immediately.' },
        { q: 'Are you available 24 hours?', a: 'Yes, we operate 24 hours a day, 7 days a week, including holidays. Ideal for early or late flights.' },
        { q: 'Do you accept card payments?', a: 'We accept cash and bank transfer. Ask about other payment methods when getting a quote.' },
        { q: 'Do you do transfers to mining sites?', a: 'Yes, we have agreements with companies and provide staff transfers to mining sites in the region.' },
      ],
    },
    destinations: {
      title: 'Places and destinations',
      subtitle: 'Get a quote via WhatsApp to confirm your transfer.',
      items: [
        'City • Airport • Mining sites — One contact for all your transfers, 24/7.',
        'Antofagasta, Tocopilla, Mejillones, Taltal, Calama: the entire region at your fingertips. Travel safe, travel on time, travel with ZAVE.',
      ],
      mapTitle: 'Antofagasta Region map',
      btn: 'Get quote via WhatsApp',
    },
    testimonials: {
      title: 'What our clients say',
      items: [
        { name: 'María G.', text: 'Excellent airport service. Punctual and very friendly. I recommend them.', role: 'Passenger' },
        { name: 'Carlos R.', text: 'We use ZAVE for staff transfers to mining sites. Always reliable.', role: 'Mining company' },
        { name: 'Ana L.', text: 'Trip to San Pedro was flawless. They know the route well and the vehicle was very comfortable.', role: 'Tourist' },
      ],
    },
  },
};
